<template>
  <div class="section-container section-white">
    <div class="section-title">UDI实现医疗器械供应链的数字化及价值</div>
    <div class="section-desc">医疗器械唯一标识（Unique Device Identification，缩写UDI）是医疗器械的"身份证"，是唯一、精准识别医疗器械的基础，贯穿医疗器械生产、流通使用 各环节、有助于医疗器械全生命周期管理。</div>
    
    <div class="udi-flow-container">
      <!-- 数字化部分 -->
      <div class="content-section">
        <div class="side-title">数字化</div>
        <div class="main-content">
          <div class="flow-diagram">
            <div class="flow-item">
              <div class="flow-content">
                <div class="flow-title">工作流</div>
                <div class="flow-desc">
                  核心是上下游之间业务订单的数字化
                </div>
              </div>
            </div>

            <div class="flow-item">
              <div class="flow-content">
                <div class="flow-title">实物流</div>
                <div class="flow-desc">
                  主要集中在医疗器械产品的出入库、库存管理环节
                </div>
              </div>
            </div>

            <div class="flow-item">
              <div class="flow-content">
                <div class="flow-title">信息流</div>
                <div class="flow-desc">
                  医疗器械产品在供应链中流转，其UDI编码下的信息流记录
                </div>
              </div>
            </div>

            <div class="flow-item">
              <div class="flow-content">
                <div class="flow-title">资金流</div>
                <div class="flow-desc">
                  本质是实际业务场景的数字化，主要是指对账、分配、返利等资金结算与实际业务场景的数字化结合
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 价值部分 -->
      <div class="content-section">
        <div class="side-title">价值</div>
        <div class="main-content">
          <div class="value-cards">
            <div class="value-card" v-for="(item, index) in valueItems" :key="index">
              <div class="value-content">
                <h4>{{ item.title }}</h4>
                <ul>
                  <li v-for="(point, pIndex) in item.points" :key="pIndex">{{ point }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/icon.css'

export default {
  name: 'UdiDigitization',
  data() {
    return {
      valueItems: [
        {
          title: '工作流价值',
          points: [
            '优化销售管理，增强实时性和准确性',
            '优化生产计划，提高运营效率',
            '优化成本控制，精准库存管理'
          ]
        },
        {
          title: '实物流价值',
          points: [
            '提高出入库效率，降低人工依赖',
            '精准库存管理，防止货损',
            '智能库存配置，提高周转效率'
          ]
        },
        {
          title: '信息流价值',
          points: [
            '满足药监部门追溯要求',
            '升级企业追溯管理能力',
            '防窜货管理',
            '电子化授权监控',
            '电子首营信息互认'
          ]
        },
        {
          title: '资金流价值',
          points: [
            '数字化对账结算',
            '自动化分配返利',
            '提高资金周转效率'
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.section-container {
  padding: 60PX 20PX;
  max-width: 1200PX;
  margin: 0 auto;
}

.section-title {
  font-size: 28PX;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin-bottom: 20PX;
}

.section-desc {
  font-size: 16PX;
  color: #666;
  text-align: center;
  max-width: 800PX;
  margin: 0 auto 60PX;
  line-height: 1.8;
}

.udi-flow-container {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.content-section {
  display: flex;
  gap: 40PX;
  margin-bottom: 0;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
}

.side-title {
  font-size: 24PX;
  font-weight: bold;
  color: #1890ff;
  writing-mode: vertical-lr;
  padding: 20PX 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
}

.main-content {
  flex: 1;
}

.flow-diagram {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20PX;
  margin-bottom: 10PX;
}

.flow-item {
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  border-radius: 14PX;
  padding: 20PX;
  box-shadow: 0 10PX 30PX rgba(24, 144, 255, 0.15);
  border: none;
  backdrop-filter: blur(10PX);
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -10PX;
    left: 50%;
    transform: translateX(-50%);
    width: 2PX;
    height: 10PX;
    background: linear-gradient(to bottom, rgba(24, 144, 255, 0.6), transparent);
  }

  .flow-content {
    .flow-title {
      font-size: 18PX;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 8PX;
    }

    .flow-desc {
      font-size: 14PX;
      color: rgba(255, 255, 255, 0.85);
      line-height: 1.5;
    }
  }

  &:hover {
    transform: translateY(-5PX);
    box-shadow: 0 15PX 40PX rgba(24, 144, 255, 0.25);
  }
}

.value-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20PX;
}

.value-card {
  background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%);
  border-radius: 14PX;
  padding: 20PX;
  box-shadow: 0 10PX 30PX rgba(24, 144, 255, 0.08);
  border: 1PX solid rgba(24, 144, 255, 0.1);
  backdrop-filter: blur(10PX);
  transition: all 0.3s ease;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -10PX;
    left: 50%;
    transform: translateX(-50%);
    width: 2PX;
    height: 10PX;
    background: linear-gradient(to top, rgba(24, 144, 255, 0.3), transparent);
  }

  .value-content {
    h4 {
      font-size: 16PX;
      font-weight: bold;
      color: #333;
      margin-bottom: 12PX;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      text-align: left;

      li {
        font-size: 13PX;
        color: #666;
        line-height: 1.6;
        position: relative;
        padding-left: 12PX;
        margin-bottom: 6PX;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 8PX;
          width: 4PX;
          height: 4PX;
          border-radius: 50%;
          background: #1890ff;
        }
      }
    }
  }

  &:hover {
    transform: translateY(-5PX);
    box-shadow: 0 15PX 40PX rgba(24, 144, 255, 0.15);
    border-color: rgba(24, 144, 255, 0.2);
  }
}

@media screen and (max-width: 1200PX) {
  .flow-diagram,
  .value-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20PX;
  }

  .flow-item,
  .value-card {
    &::after,
    &::before {
      display: none;
    }
  }
}

@media screen and (max-width: 768PX) {
  .flow-diagram,
  .value-cards {
    grid-template-columns: 1fr;
  }

  .flow-item,
  .value-card {
    padding: 16PX;
  }
}

@media screen and (max-width: 480PX) {
  .content-section {
    gap: 15PX;
    margin-bottom: 30PX;
  }

  .side-title {
    font-size: 18PX;
    margin: 25PX 0 12PX;
  }
}
</style> 